import ContactUsModal from '@/components/modals/ContactUsModal.vue';

export default {
  components: {
    ContactUsModal,
  },
  data() {
    return {
      showContactUsModal: false,
    };
  },
  methods: {
    onCloseContactUsModal() {
      this.showContactUsModal = false;
    },
    openContactUsModal() {
      this.showContactUsModal = true;
    },
  },
};
